function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { defineComponent, openBlock, createElementBlock, normalizeClass, unref, Fragment, renderList, toDisplayString, createCommentVNode, createElementVNode, renderSlot } from 'vue';
import '../../../hooks/index.mjs';
import { dateTableProps, dateTableEmits } from './date-table.mjs';
import { useDateTable } from './use-date-table.mjs';
import _export_sfc from '../../../_virtual/plugin-vue_export-helper.mjs';
import { useNamespace } from '../../../hooks/use-namespace/index.mjs';
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = ["onClick"];
const __default__ = defineComponent({
  name: "DateTable"
});
const _sfc_main = /* @__PURE__ */defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  props: dateTableProps,
  emits: dateTableEmits,
  setup(__props, _ref) {
    let expose = _ref.expose,
      emit = _ref.emit;
    const props = __props;
    const _useDateTable = useDateTable(props, emit),
      isInRange = _useDateTable.isInRange,
      now = _useDateTable.now,
      rows = _useDateTable.rows,
      weekDays = _useDateTable.weekDays,
      getFormattedDate = _useDateTable.getFormattedDate,
      handlePickDay = _useDateTable.handlePickDay,
      getSlotData = _useDateTable.getSlotData;
    const nsTable = useNamespace("calendar-table");
    const nsDay = useNamespace("calendar-day");
    const getCellClass = _ref2 => {
      let text = _ref2.text,
        type = _ref2.type;
      const classes = [type];
      if (type === "current") {
        const date = getFormattedDate(text, type);
        if (date.isSame(props.selectedDay, "day")) {
          classes.push(nsDay.is("selected"));
        }
        if (date.isSame(now, "day")) {
          classes.push(nsDay.is("today"));
        }
      }
      return classes;
    };
    expose({
      getFormattedDate
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("table", {
        class: normalizeClass([unref(nsTable).b(), unref(nsTable).is("range", unref(isInRange))]),
        cellspacing: "0",
        cellpadding: "0"
      }, [!_ctx.hideHeader ? (openBlock(), createElementBlock("thead", _hoisted_1, [(openBlock(true), createElementBlock(Fragment, null, renderList(unref(weekDays), day => {
        return openBlock(), createElementBlock("th", {
          key: day
        }, toDisplayString(day), 1);
      }), 128))])) : createCommentVNode("v-if", true), createElementVNode("tbody", null, [(openBlock(true), createElementBlock(Fragment, null, renderList(unref(rows), (row, index) => {
        return openBlock(), createElementBlock("tr", {
          key: index,
          class: normalizeClass({
            [unref(nsTable).e("row")]: true,
            [unref(nsTable).em("row", "hide-border")]: index === 0 && _ctx.hideHeader
          })
        }, [(openBlock(true), createElementBlock(Fragment, null, renderList(row, (cell, key) => {
          return openBlock(), createElementBlock("td", {
            key,
            class: normalizeClass(getCellClass(cell)),
            onClick: $event => unref(handlePickDay)(cell)
          }, [createElementVNode("div", {
            class: normalizeClass(unref(nsDay).b())
          }, [renderSlot(_ctx.$slots, "date-cell", {
            data: unref(getSlotData)(cell)
          }, () => [createElementVNode("span", null, toDisplayString(cell.text), 1)])], 2)], 10, _hoisted_2);
        }), 128))], 2);
      }), 128))])], 2);
    };
  }
}));
var DateTable = /* @__PURE__ */_export_sfc(_sfc_main, [["__file", "date-table.vue"]]);
export { DateTable as default };